<app-loader></app-loader>

<app-side-bar-settings></app-side-bar-settings>

<!-- Wrapper [START] -->
<div class="wrapper">
  <app-side-bar2></app-side-bar2>
  <app-nav-bar1></app-nav-bar1>
  <!--Content [START]-->
  <div id="content-page" class="content-page">
    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>
  </div>
  <!-- Content [END] -->
  <app-right-side-bar></app-right-side-bar>
  <!-- Footer -->
  <footer class="bg-white iq-footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6">
          <ul class="list-inline mb-0">
            <li class="list-inline-item"><a href="privacy-policy.html">Privacy Policy</a></li>
            <li class="list-inline-item"><a href="terms-of-service.html">Terms of Use</a></li>
          </ul>
        </div>
        <div class="col-lg-6 text-right">
          Copyright 2020 <a href="#">Vito</a> All Rights Reserved.
        </div>
      </div>
    </div>
  </footer>
  <!-- Footer END -->
</div>
<!-- Wrapper [END] -->


